import hljs from 'highlight.js';
import 'highlight.js/styles/github-dark-dimmed.css';

/**
 * @file
 * Menu toggle
 */
(function (Drupal, drupalSettings) {
  Drupal.behaviors.codeHighlight = {
    attach: function (context, settings) {
      const elements = once('highlightjs', 'pre code', context);
      elements.forEach((element) => {
        hljs.highlightElement(element);
      });
    }
  };
})(Drupal, drupalSettings);
